// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getOpenPipsSummary} from '../../shared/repositories';

export const readOpenPipsSummary = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getOpenPipsSummary();

            dispatch({
                data,
                type: actions.READ_OPEN_PIP_PRODUCTS_SUMMARY_SUCCESS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/pip/open-pips/action-creators/open-pips-summary.js